// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.specialoffers.RentalManagerUserPropertySpecialOfferV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { DeleteListingSpecialOfferRequestDto } from '../..';

export const RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/specialOffers/delete';

/**
 * Delete a listing special offer
 */
export const RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete = (
  postData: DeleteListingSpecialOfferRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteListingSpecialOfferRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
